/* Art by Sandhya — Threshold of the Atelier
   Motion: 600ms opacity + 24px upward drift via IntersectionObserver.
   Hero overlay: 1.2s opacity reveal on load.
   WhatsApp float: appears after scrolling past hero (~88vh).
*/

(function () {
  'use strict';

  // -------- Scroll reveal --------
  var reveals = document.querySelectorAll('.reveal');

  function showAll() {
    reveals.forEach(function (el, i) {
      // gentle stagger for sibling reveals inside same parent
      var delay = (el.dataset.delay ? +el.dataset.delay : 0);
      setTimeout(function () { el.classList.add('is-in'); }, delay);
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    reveals.forEach(function (el) { io.observe(el); });
  } else {
    showAll();
  }

  // Hero overlay always reveals on load
  var heroOverlay = document.querySelector('.hero-overlay');
  if (heroOverlay) {
    requestAnimationFrame(function () {
      heroOverlay.classList.add('is-in');
    });
  }

  // Fallback for static screenshot rendering: reveal everything after 1.2s
  setTimeout(function () {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
    var wa = document.querySelector('.wa-float');
    if (wa) wa.classList.add('is-visible');
  }, 1200);

  // -------- Floating WhatsApp: appears after hero --------
  var waBtn = document.querySelector('.wa-float');
  function onScroll() {
    if (!waBtn) return;
    var threshold = window.innerHeight * 0.88;
    if (window.scrollY > threshold) {
      waBtn.classList.add('is-visible');
    } else {
      waBtn.classList.remove('is-visible');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // -------- Hamburger (mobile) — drawer toggle --------
  var hamb = document.querySelector('.hamburger');
  var siteHeader = document.querySelector('.site-header');
  if (hamb && siteHeader) {
    hamb.addEventListener('click', function () {
      var isOpen = siteHeader.classList.toggle('is-open');
      hamb.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      // Prevent body scroll when drawer open
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // Close drawer on outside click
    document.addEventListener('click', function (e) {
      if (siteHeader.classList.contains('is-open') && !siteHeader.contains(e.target)) {
        siteHeader.classList.remove('is-open');
        hamb.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
    // Close drawer on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && siteHeader.classList.contains('is-open')) {
        siteHeader.classList.remove('is-open');
        hamb.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        hamb.focus();
      }
    });
  }
})();
